import React, { useEffect, useState } from "react"
import { getValidLocaleCode } from "@utils/localisation"
//import { generateData } from "./helpers"
import { generateData } from "./helpers2"
import { ChartFilters } from "./ChartFilters"
import { ChartRender } from "./ChartRender"

export const AVAILABLE_RANGES = [
  { id: "5", text: "5D" },
  { id: "30", text: "1M" },
  { id: "180", text: "6M" },
  { id: "YTD", text: "YTD" },
  { id: "365", text: "1Y" },
  { id: "730", text: "2Y" },
]

export default ({
  countryCurrency,
  locale,
  calculatedPrices,
  mobileMenuAnchorEl,
  mobileMenuOpen,
  onMobileMenuClose,
  localStoragePrefix,
  defaultButtonIndex,
}) => {
  // Find default range based on defaultButtonIndex
  const defaultRangeItem = AVAILABLE_RANGES[defaultButtonIndex].id

  const [range, setRange] = useState(defaultRangeItem)

  const [currency, setCurrency] = useState(countryCurrency)
  const [data, setData] = useState(
    generateData(range, currency || countryCurrency, calculatedPrices, locale)
  )
  // Update the table data with all the selected filters
  useEffect(() => {
    const newData = generateData(
      range,
      currency || countryCurrency,
      calculatedPrices,
      locale
    )
    setData(newData)
  }, [range, currency])

  const selectCurrency = id => {
    setCurrency(id)
  }

  const selectRange = id => {
    setRange(id)
  }

  return (
    <div className="md:bg-white">
      <ChartFilters
        selectCurrency={selectCurrency}
        selectRange={selectRange}
        availableCurrencies={calculatedPrices.availableCurrencies}
        mobileMenuAnchorEl={mobileMenuAnchorEl}
        mobileMenuOpen={mobileMenuOpen}
        onMobileMenuClose={onMobileMenuClose}
        localStoragePrefix={localStoragePrefix}
        defaultButtonIndex={defaultButtonIndex}
        availableRanges={AVAILABLE_RANGES}
      />

      <ChartRender
        data={data}
        range={range}
        currency={currency}
        locale={locale}
      />
    </div>
  )
}
